//------------------------------------------------------------------------------
// JS Util Functions
//------------------------------------------------------------------------------

// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
export function createId() {
    return 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function(c) {
        var r = Math.random() * 16 | 0;
        return r.toString(16);
    });
}
    
export function deepCopy(thing) {
    return JSON.parse(JSON.stringify(thing));
}

export function parseSemVer(version) {
    var tmp = version.split('.');
    return {
        major: parseInt(tmp[0], 10),
        minor: parseInt(tmp[1], 10),
        patch: parseInt(tmp[2], 10)
    };
}

// returns true if version is >= minimum
export function compareSemVer(version, minimum) {
    version = parseSemVer(version);
    minimum = parseSemVer(minimum);

    var versionNum = (version.major * 10000 * 10000) +
        (version.minor * 10000) + version.patch;
    var minimumNum = (minimum.major * 10000 * 10000) +
        (minimum.minor * 10000) + minimum.patch;

    return (versionNum >= minimumNum);
}

    
export function isTouchDevice() {
    return ('ontouchstart' in document.documentElement);
}
  
// reference: http://www.quirksmode.org/js/detect.html
export function isMSIE() {
    return (navigator && navigator.userAgent &&
        navigator.userAgent.search(/MSIE/) !== -1);
}
  
export function stopDefault(e) {
    e.preventDefault();
}


// WEBPACK FOOTER //
// ./src/JsUtils.js